import HeroSection from "./components/HeroSection";
import TrainingInAction from "./components/TrainingInAction";
import AboutPreview from "./components/AboutPreview";
import InstructorFeature from "./components/InstructorFeature";
import InstructorsDuo from "./components/InstructorsDuo";
import CoursesPreview from "./components/CoursesPreview";
import WhyChooseUs from "./components/WhyChooseUs";
import TestimonialsPreview from "./components/TestimonialsPreview";
import CTASection from "./components/CTASection";
import LearnWithUs from "./components/LearnWithUs";

const SITE_URL = import.meta.env.VITE_SITE_URL || '';

export default function HomePage() {
  const schema = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'WebSite',
        '@id': `${SITE_URL}/#website`,
        name: 'Cardiocraft CPR',
        url: `${SITE_URL}/`,
        potentialAction: {
          '@type': 'SearchAction',
          target: `${SITE_URL}/courses`,
          'query-input': 'required name=search_term_string',
        },
      },
      {
        '@type': 'EducationalOrganization',
        '@id': `${SITE_URL}/#organization`,
        name: 'Cardiocraft CPR',
        url: SITE_URL,
        logo: 'https://public.readdy.ai/ai/img_res/0bc8c1a5-8349-4da7-bc3f-8127b6f3ae55.png',
        description:
          'RN-led CPR and life support certification courses in Kissimmee, FL. BLS, ACLS, PALS, CPR/AED and First Aid training aligned with American Heart Association standards.',
        address: {
          '@type': 'PostalAddress',
          streetAddress: '1627 East Vine Street, Suite 203',
          addressLocality: 'Kissimmee',
          addressRegion: 'FL',
          postalCode: '34744',
          addressCountry: 'US',
        },
        geo: {
          '@type': 'GeoCoordinates',
          latitude: 28.2919889,
          longitude: -81.4073246,
        },
        telephone: '+14075643966',
        email: 'cardiocraftcpr@gmail.com',
        areaServed: {
          '@type': 'City',
          name: 'Kissimmee',
        },
        sameAs: [],
        hasOfferCatalog: {
          '@type': 'OfferCatalog',
          name: 'CPR & Life Support Courses',
          itemListElement: [
            {
              '@type': 'Offer',
              itemOffered: {
                '@type': 'Course',
                name: 'BLS Certification',
                description: 'Basic Life Support certification for healthcare professionals',
              },
            },
            {
              '@type': 'Offer',
              itemOffered: {
                '@type': 'Course',
                name: 'ACLS Certification',
                description: 'Advanced Cardiovascular Life Support certification',
              },
            },
            {
              '@type': 'Offer',
              itemOffered: {
                '@type': 'Course',
                name: 'PALS Certification',
                description: 'Pediatric Advanced Life Support certification',
              },
            },
          ],
        },
      },
      {
        '@type': 'LocalBusiness',
        '@id': `${SITE_URL}/#localbusiness`,
        name: 'Cardiocraft CPR',
        url: SITE_URL,
        image: 'https://public.readdy.ai/ai/img_res/0bc8c1a5-8349-4da7-bc3f-8127b6f3ae55.png',
        telephone: '+14075643966',
        email: 'cardiocraftcpr@gmail.com',
        address: {
          '@type': 'PostalAddress',
          streetAddress: '1627 East Vine Street, Suite 203',
          addressLocality: 'Kissimmee',
          addressRegion: 'FL',
          postalCode: '34744',
          addressCountry: 'US',
        },
        geo: {
          '@type': 'GeoCoordinates',
          latitude: 28.2919889,
          longitude: -81.4073246,
        },
        priceRange: '$$',
        openingHoursSpecification: [
          {
            '@type': 'OpeningHoursSpecification',
            dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
            opens: '08:00',
            closes: '20:00',
          },
        ],
      },
    ],
  };

  return (
    <main>
      <title>Cardiocraft CPR | CPR Classes Kissimmee | BLS ACLS PALS Certification</title>
      <meta name="description" content="Top-rated CPR classes in Kissimmee, FL. BLS certification, ACLS, PALS, and same-day CPR certification taught by Registered Nurse instructors. American Heart Association–aligned training at Cardiocraft CPR." />
      <meta name="keywords" content="CPR classes Kissimmee, BLS certification Kissimmee, ACLS classes Kissimmee, PALS certification Kissimmee, same-day CPR certification" />
      <link rel="canonical" href={`${SITE_URL}/`} />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
      />
      <HeroSection />
      <TrainingInAction />
      <AboutPreview />
      <InstructorFeature />
      <InstructorsDuo />
      <CoursesPreview />
      <WhyChooseUs />
      <LearnWithUs />
      <TestimonialsPreview />
      <CTASection />
    </main>
  );
}
